import { apiRequest } from "../lib/apiClient";
import type { CustomerCreate, CustomerOut } from "./types";

export async function listCustomers(accessToken: string): Promise<CustomerOut[]> {
  return apiRequest<CustomerOut[]>("/customers", { accessToken });
}

export async function createCustomer(accessToken: string, body: CustomerCreate): Promise<CustomerOut> {
  return apiRequest<CustomerOut>("/customers", { method: "POST", accessToken, body });
}

export async function getCustomer(accessToken: string, customerId: string): Promise<CustomerOut> {
  return apiRequest<CustomerOut>(`/customers/${customerId}`, { accessToken });
}
